import axios from 'axios'
import { getToken, removeToken, setToken } from './auth'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 0
})

service.interceptors.request.use(
  async config => {
    config.headers.post['Content-Type'] = 'application/json multipart/form-data'
    config.headers.common['Authorization'] = 'Bearer ' + getToken('tokenYE')
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (response.data.frontEndVersion) {
      const verssion = getToken('frontend-version')
      if (!verssion) {
        setToken('frontend-version', response.data.frontEndVersion)
        location.reload()
      }
      if (response.data.frontEndVersion !== verssion) {
        setToken('frontend-version', response.data.frontEndVersion)
        location.reload()
      }
    }
    return Promise.resolve(response)
  },
  async error => {
    const { status: statusKod } = error.response
    if (statusKod === 401) {
      Sil()
      location.reload()
    } else {
      return Promise.reject(error.response)
    }
  }
)

function Sil () {
  removeToken('tokenYE')
}

export default service
